import {
  IManualActionsTableReport,
  IManualActionsTableSearchParam,
} from "../../Interfaces/manualInterfaces";
import { getManualActionsTable } from "../../Requests/manualRequests";
import { CommonTableUI } from "../TableTemplate/common";
import TableTemplate from "../TableTemplate/tableTemplate";

interface IProps {
  searchParams: IManualActionsTableSearchParam;
}

const ActionsTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IManualActionsTableSearchParam, IManualActionsTableReport>
      getDataTable={getManualActionsTable}
      TableUI={({ reports }) => <CommonTableUI reports={reports} />}
      showIsLoading
      initialSearchParameters={searchParams}
    />
  );
};

export default ActionsTable;
